import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'portal-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

    constructor(public auth: AuthenticationService, private dialog: MatDialog) {
    }

    ngOnInit() {
        this.dialog.closeAll();
    }
}